<ng-container *ngIf="isAdmin || ticket?.erstellt_von === currentUser.benutzer_id || ticket.zugewiesen || isSupportUser">
    <div style="padding: 12px 24px">
        <div class="one-row">
            <button (click)="goBack()" color="accent" mat-icon-button>
                <mat-icon>chevron_left</mat-icon>
            </button>
            <h1 style="margin-top: 24px">VETVET-{{ ticket.ticket_id }}: {{ ticket.titel }}</h1>
            <span class="spacer"></span>

            <div
                [style.border-color]="getColor(ticket.status_id)"
                [style.color]="getColor(ticket.status_id)"
                class="status-field"
            >
                {{ ticket.status }}
            </div>

            <button
                *kienePermission="[10060, 10061, 10062, 10063, 10064, 10065, 10066]"
                [disabled]="isLoadingOrSaving"
                [matMenuTriggerFor]="tableMenu"
                color="accent"
                mat-icon-button
                matTooltip="Status ändern"
            >
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #tableMenu="matMenu" style="min-width: 20vw">
                <ng-container *kienePermission="[10060]">
                    <button
                        (click)="setStatus(224)"
                        *ngIf="ticket.status_id === 225"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>fiber_new</mat-icon>
                        <span>Neu</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10061]">
                    <button
                        (click)="setStatus(225)"
                        *ngIf="ticket.status_id === 224 || ticket.status_id === 227"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>verified</mat-icon>
                        <span>Freigeben</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10062]">
                    <button
                        (click)="setStatus(226)"
                        *ngIf="ticket.status_id === 224"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>cancel</mat-icon>
                        <span>Ablehnen</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10063]">
                    <button
                        (click)="setStatus(227)"
                        *ngIf="ticket.status_id === 225 || ticket.status_id === 228"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>hourglass_top</mat-icon>
                        <span>In Bearbeitung</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10064]">
                    <button
                        (click)="setStatus(228)"
                        *ngIf="ticket.status_id === 227"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>done</mat-icon>
                        <span>Fertig</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10065]">
                    <button
                        (click)="setStatus(229)"
                        *ngIf="ticket.status_id === 228"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>publish</mat-icon>
                        <span>Eingespielt</span>
                    </button>
                </ng-container>
                <ng-container *kienePermission="[10066]">
                    <button
                        (click)="setStatus(230)"
                        *ngIf="ticket.status_id === 224 || ticket.status_id === 225 || ticket.status_id === 227"
                        mat-menu-item
                        style="border-radius: 12px; margin: 6px; width: calc(100% - 12px)"
                    >
                        <mat-icon>check_circle_outline</mat-icon>
                        <span>Obsolet</span>
                    </button>
                </ng-container>
            </mat-menu>
        </div>

        <mat-tab-group
            #tabGroup
            (selectedTabChange)="tabChanged($event)"
            *ngIf="ticket"
            [selectedIndex]="selectedIndex"
        >
            <mat-tab *kienePermission="[10033]" label="Allgemein">
                <div class="one-row">
                    <div style="width: calc(75% - 48px); align-self: flex-start">
                        <ng-container *ngIf="ticket.status_id === 224">
                            <mat-form-field style="width: 100%; margin-top: 12px">
                                <mat-label>Titel</mat-label>
                                <input [(ngModel)]="ticket.titel" [disabled]="canNotEdit" matInput required />
                            </mat-form-field>

                            <mat-form-field style="width: 100%">
                                <mat-label style="margin-top: 60px">Beschreibung</mat-label>
                                <textarea
                                    [(ngModel)]="ticket.beschreibung"
                                    [disabled]="canNotEdit"
                                    matInput
                                    placeholder="Beschreibung"
                                    required
                                    rows="5"
                                ></textarea>
                            </mat-form-field>
                            <!--                speichern button rechts-->
                            <div class="one-row" style="margin-top: 12px">
                                <span class="spacer"></span>
                                <button
                                    (click)="updateBeschreibung()"
                                    *ngIf="!canNotEdit"
                                    [disabled]="isLoadingOrSaving"
                                    color="primary"
                                    mat-stroked-button
                                >
                                    Speichern
                                </button>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="ticket.status_id != 224">
                            <div style="padding: 12px; background-color: white; border-radius: 12px; margin-top: 12px">
                                <h3>Beschreibung</h3>
                                <p>{{ ticket?.beschreibung }}</p>
                            </div>
                        </ng-container>

                        <!--                Kommentare-->
                        <ng-container *kienePermission="[10033]">
                            <h3 style="margin-top: 40px">Kommentare</h3>
                            <div style="width: 100%; margin-top: 36px">
                                <div *ngFor="let comment of ticket.kommentare" class="comment" style="margin-top: 12px">
                                    <div class="one-row">
                                        <span
                                            ><strong>{{ comment.ersteller }}</strong></span
                                        >

                                        <span style="margin-left: 12px">
                                            {{ comment?.erstellt | date: "dd.MM.yyyy HH:mm" }}
                                        </span>

                                        <mat-icon
                                            *ngIf="!comment?.oeffentlich"
                                            matTooltip="Interner Kommentar"
                                            style="margin-left: 12px; transform: scale(0.7)"
                                        >
                                            visibility_off
                                        </mat-icon>

                                        <span class="spacer"></span>

                                        <ng-container *ngIf="canDeleteComment(comment) || canEditComment(comment)">
                                            <button
                                                [disabled]="isLoadingOrSaving"
                                                [matMenuTriggerFor]="commentMenu"
                                                color="accent"
                                                mat-icon-button
                                            >
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                            <mat-menu #commentMenu="matMenu" style="min-width: 20vw">
                                                <button
                                                    (click)="editComment(comment)"
                                                    *ngIf="canEditComment(comment)"
                                                    mat-menu-item
                                                >
                                                    <mat-icon>edit</mat-icon>
                                                    Kommentar bearbeiten
                                                </button>
                                                <button
                                                    (click)="deleteComment(comment)"
                                                    *ngIf="canDeleteComment(comment)"
                                                    mat-menu-item
                                                >
                                                    <mat-icon>delete</mat-icon>
                                                    Kommentar löschen
                                                </button>
                                            </mat-menu>
                                        </ng-container>
                                    </div>
                                    <div
                                        class="comment-content"
                                        style="margin-top: 6px; width: 95%; font-style: italic"
                                    >
                                        <span>{{ comment.kommentar }}</span>
                                    </div>
                                    <mat-divider style="margin-top: 6px"></mat-divider>
                                </div>
                            </div>
                            <div class="one-row">
                                <mat-form-field
                                    *kienePermission="[10036]"
                                    [ngStyle]="{ width: isAdmin ? '80%' : '100%' }"
                                >
                                    <mat-label>Kommentar schreiben</mat-label>
                                    <input
                                        (keydown.enter)="neuerKommentarCtrl.value ? addComment() : null"
                                        [formControl]="neuerKommentarCtrl"
                                        matInput
                                        required
                                    />
                                    <button
                                        (click)="addComment()"
                                        [disabled]="isLoadingOrSaving"
                                        color="accent"
                                        mat-icon-button
                                        matSuffix
                                    >
                                        <mat-icon>send</mat-icon>
                                    </button>
                                </mat-form-field>
                                <ng-container *ngIf="isAdmin">
                                    <span class="spacer"></span>
                                    <label>
                                        <span>Öffentlicher Kommentar</span>
                                        <mat-slide-toggle
                                            [disabled]="isLoadingOrSaving"
                                            [formControl]="neuerKommentarPublicCtrl"
                                            style="margin-left: 12px"
                                        ></mat-slide-toggle>
                                    </label>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>

                    <span class="spacer"></span>

                    <!--KEY_VALUE_LIST-->
                    <div style="width: 25%; align-self: flex-start; padding-top: 12px">
                        <kiene-key-value-list>
                            <!--                    <div class="one-row"-->
                            <!--                         style="margin-top: 12px; width: 9vw">-->
                            <!-- frontend/src/app/ticketsystem/ticket-details/ticket-details.component.html -->
                            <ng-container *ngIf="isAdmin">
                                <kiene-key-value-list-item
                                    (actionClicked)="setPrioritaet()"
                                    [actionButtonDisabled]="ticket.status_id != 224"
                                    [icon]="'info'"
                                    [ngStyle]="{ color: getPrioritaetTextColor().color }"
                                    [value]="getPrioritaetTextColor().text"
                                    actionButtonIcon="edit"
                                    key="Priorität"
                                    style="min-width: 9vw; font-weight: bold"
                                >
                                </kiene-key-value-list-item>
                            </ng-container>

                            <kiene-key-value-list-item
                                (actionClicked)="setType()"
                                *ngIf="isAdmin"
                                [icon]="'pest_control'"
                                [value]="ticket.tickettyp"
                                actionButtonIcon="edit"
                                key="Supporttyp: "
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'person'"
                                [value]="ticket.ersteller"
                                key="erstellt von: "
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'event_upcoming'"
                                [value]="ticket.erstellt | date: 'dd.MM.yyyy HH:mm'"
                                key="erstellt am:"
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'domain_disabled'"
                                [value]="getKundenInfos(ticket)"
                                key="Betrieb:"
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'dialpad'"
                                [value]="ticket.vvvo"
                                key="VVVO:"
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'link'"
                                [value]="ticket.frontend_url"
                                key="Frontend-URL:"
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>

                            <kiene-key-value-list-item
                                [icon]="'link'"
                                [value]="ticket.backend_url"
                                key="Backend-URL:"
                                style="margin-top: 12px"
                            >
                            </kiene-key-value-list-item>
                            <kiene-autocomplete
                                (elementSelected)="addBenutzer($event)"
                                *ngIf="isAdmin"
                                [apiUrl]="'benutzer/'"
                                [clearAfterSelect]="true"
                                [disabled]="isLoadingOrSaving"
                                [displayFields]="['vorname', 'nachname']"
                                [focus]="false"
                                [required]="false"
                                [showClear]="true"
                                placeholder="Person zuweisen"
                                style="margin-top: 48px"
                            >
                            </kiene-autocomplete>
                            <ng-container *ngIf="ticket?.zuweisungen?.length > 0">
                                <h3>zugewiesen:</h3>
                                <mat-list>
                                    <mat-list-item *ngFor="let tz of ticket.zuweisungen">
                                        <button *kienePermission="[10082]" (click)="deleteBenutzer(tz)" mat-icon-button>
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                        <span style="margin-left: 12px">{{ tz.vorname }} {{ tz.nachname }}</span>
                                    </mat-list-item>
                                </mat-list>
                            </ng-container>
                            <h3 *ngIf="ticket.zugewiesen && !isAdmin">Das Ticket ist Ihnen zugewiesen</h3>
                        </kiene-key-value-list>
                    </div>
                </div>
            </mat-tab>

            <mat-tab *kienePermission="[10051]" label="Dateien">
                <mat-progress-bar *ngIf="isLoadingOrSaving" mode="indeterminate"></mat-progress-bar>

                <h2 style="margin-top: 24px">Dateien</h2>

                <!-- Datei hinzufügen Button -->
                <div *kienePermission="[10050]" style="width: 100%">
                    <div class="one-row">
                        <input
                            #fileInput
                            (change)="onFileChange($event)"
                            accept=".jpg,.jpeg,.png,.pdf,.csv,.xls,.xlsx"
                            hidden
                            multiple
                            type="file"
                        />
                        <button
                            (click)="fileInput.click()"
                            [disabled]="isLoadingOrSaving"
                            color="primary"
                            mat-stroked-button
                        >
                            Weitere Dateien hinzufügen
                        </button>
                    </div>
                </div>

                <!-- Datei-Liste -->
                <div class="one-row" style="margin-top: 12px">
                    <mat-list style="width: 65%">
                        <mat-list-item
                            (click)="openOrDownloadFile(file)"
                            *ngFor="let file of ticket?.dateien"
                            style="cursor: pointer"
                        >
                            <div class="one-row" style="margin-right: 24px">
                                <h4 mat-line style="width: 40%"
                                    ><strong>{{ file?.dateiname }}</strong></h4
                                >
                                <p mat-line style="margin-left: 24px; width: 10%"
                                    >{{ file?.size / 1024 | number: "1.0-0" }}
                                    KB
                                </p>
                                <p mat-line style="margin-left: 24px; width: 25%">Ersteller: {{ file?.ersteller }}</p>
                                <p mat-line style="margin-left: 24px; width: 25%">
                                    Erstellt: {{ file?.erstellt | date: "dd.MM.yyyy HH:mm" }}</p
                                >
                            </div>
                            <span class="spacer"></span>

                            <!-- Drei-Punkte-Menü -->
                            <ng-container *kienePermission="[10051, 10053]">
                                <button
                                    (click)="$event.stopPropagation()"
                                    [disabled]="isLoadingOrSaving"
                                    [matMenuTriggerFor]="fileMenu"
                                    mat-icon-button
                                >
                                    <mat-icon>more_vert</mat-icon>
                                </button>

                                <mat-menu #fileMenu="matMenu">
                                    <button (click)="openOrDownloadFile(file)" mat-menu-item>
                                        <mat-icon>attach_file</mat-icon>
                                        Öffnen / Herunterladen
                                    </button>
                                    <ng-container *kienePermission="[10053]">
                                        <button (click)="deleteFile(file)" *ngIf="canDeleteFile(file)" mat-menu-item>
                                            <mat-icon>delete</mat-icon>
                                            Löschen
                                        </button>
                                    </ng-container>
                                </mat-menu>
                            </ng-container>
                        </mat-list-item>
                    </mat-list>
                </div>
            </mat-tab>

            <mat-tab *kienePermission="[10070]" label="Statuswechsel">
                <ng-container *matTabContent>
                    <kiene-ticket-statushistorie></kiene-ticket-statushistorie>
                </ng-container>
            </mat-tab>
        </mat-tab-group>
    </div>
</ng-container>
